<script lang="ts" setup>
import {
  type FieldValidatorProps,
  useFieldValidator
} from '../composables/field-validator.composable'

type Props = FieldValidatorProps

const props = defineProps<Props>()
const [model] = defineModel()

const { isValid, validate, error, isPristine, isDirty } = useFieldValidator(model, props)

defineExpose({ validate, isValid })
</script>
<template>
  <slot
    :error="error"
    :isPristine="isPristine"
    :isValid="isValid"
    :validate="validate"
    :value="model"
  ></slot>
</template>
